import styled from 'styled-components';
import { StyledTrackingOrderStepListProps } from './TrackingOrderStepList.types';

export const StyledTrackingOrderStepList = styled.div<StyledTrackingOrderStepListProps>`
  .tracking-order-step-list__stepper {
    display: grid;
    justify-content: space-between;
    grid-auto-columns: auto;
    padding-bottom: 4rem;
    .tracking-order-step-list__step-item {
      grid-row: 1;
      &--is-current {
        position: relative;
        .tracking-order-step-list__stepper-status {
          position: absolute;
          top: 100%;
          width: max-content;
        }
      }
    }
  }

  .tracking-order-step-list__stepper-status {
    display: flex;
    flex-direction: column;
  }

  ${(props) => props.customStyle}
`;
